enum StatusBoardGrouping {
  WORK_STATUS = 'work',
  VEHICLE_STATUS = 'vehicle',
}

export default StatusBoardGrouping;